import { DietaryOptionModule_allOptions, DietaryOptionModule_toCode, AttendanceStatus, AttendanceStatusModule_toInt, AgeCategory, AgeCategoryModule_toInt, Gender, GenderModule_toInt } from "../Shared/Types.js";
import { t } from "../Lang.js";
import { Guests_deleteGuest, Common_save, Guests_saving, Guests_notes, Guests_tagsHint, Guests_tags, Guests_wheelchair, Guests_dietaryOther, Guests_dietaryTagsHint, Guests_dietaryTags, Guests_rankPlaceholder, Guests_rank, Guests_titlePlaceholder, Guests_title, Guests_statusColumn, Guests_age, Guests_gender, Guests_swapNames, Guests_fullNamePlaceholder, Guests_fullName, Guests_lastNamePlaceholder, Guests_lastName, Guests_firstNamePlaceholder, Guests_firstName, Common_cancel, Guests_newTitle, Guests_editTitle, Enum_Attendance_notAttending, Enum_Attendance_attending, Enum_Attendance_invited, Enum_Attendance_notInvited, Enum_Attendance_active, Enum_Age_senior, Enum_Age_adult, Enum_Age_teen, Enum_Age_child, Enum_Gender_unspecified, Enum_Gender_nonbinary, Enum_Gender_female, Enum_Gender_male } from "../Shared/Tr.js";
import { map, ofArray } from "../fable_modules/fable-library-js.4.28.0/List.js";
import { createElement } from "react";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { empty, collect, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.28.0/Seq.js";
import { Msg } from "../App/Messages.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.28.0/Util.js";
import { formTextarea, formInput } from "./Components.js";
import { tryParse } from "../fable_modules/fable-library-js.4.28.0/Int32.js";
import { FSharpRef } from "../fable_modules/fable-library-js.4.28.0/Types.js";
import { View } from "./TagInput.js";
import { GuestEditFormModule_isValid } from "../Pages/Event/State.js";

function genderOptions() {
    return ofArray([[GenderModule_toInt(new Gender(0, [])), t(Enum_Gender_male)], [GenderModule_toInt(new Gender(1, [])), t(Enum_Gender_female)], [GenderModule_toInt(new Gender(2, [])), t(Enum_Gender_nonbinary)], [GenderModule_toInt(new Gender(3, [])), t(Enum_Gender_unspecified)]]);
}

function ageCategoryOptions() {
    return ofArray([[AgeCategoryModule_toInt(new AgeCategory(0, [])), t(Enum_Age_child)], [AgeCategoryModule_toInt(new AgeCategory(1, [])), t(Enum_Age_teen)], [AgeCategoryModule_toInt(new AgeCategory(2, [])), t(Enum_Age_adult)], [AgeCategoryModule_toInt(new AgeCategory(3, [])), t(Enum_Age_senior)]]);
}

function attendanceStatusOptions() {
    return ofArray([[AttendanceStatusModule_toInt(new AttendanceStatus(0, [])), t(Enum_Attendance_active)], [AttendanceStatusModule_toInt(new AttendanceStatus(1, [])), t(Enum_Attendance_notInvited)], [AttendanceStatusModule_toInt(new AttendanceStatus(2, [])), t(Enum_Attendance_invited)], [AttendanceStatusModule_toInt(new AttendanceStatus(3, [])), t(Enum_Attendance_attending)], [AttendanceStatusModule_toInt(new AttendanceStatus(4, [])), t(Enum_Attendance_notAttending)]]);
}

export function view(form, allTags, dispatch) {
    let elems_16;
    const isEditing = form.Id != null;
    const title = isEditing ? t(Guests_editTitle) : t(Guests_newTitle);
    const showValidation = form.ValidationAttempt > 0;
    const vKey = form.ValidationAttempt | 0;
    return createElement("div", createObj(ofArray([["className", "guest-edit-panel"], (elems_16 = toList(delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["className", "flex items-center justify-between mb-2"], (elems = [createElement("h3", {
            children: title,
        }), createElement("button", {
            className: "btn btn-sm btn-secondary",
            children: t(Common_cancel),
            onClick: (_arg) => {
                dispatch(new Msg(51, []));
            },
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let matchValue;
            return append((matchValue = form.Error, (matchValue == null) ? singleton(defaultOf()) : singleton(createElement("div", {
                className: "error-message",
                children: matchValue,
            }))), delay(() => append(isEditing ? append(singleton(formInput(t(Guests_firstName), form.FirstName, t(Guests_firstNamePlaceholder), (v) => {
                dispatch(new Msg(62, [v]));
            }, form.IsSubmitting, true, showValidation && (form.FirstName.trim() === ""), vKey)), delay(() => singleton(formInput(t(Guests_lastName), form.LastName, t(Guests_lastNamePlaceholder), (v_1) => {
                dispatch(new Msg(63, [v_1]));
            }, form.IsSubmitting, true, showValidation && (form.LastName.trim() === ""), vKey)))) : append(singleton(formInput(t(Guests_fullName), form.FullNameInput, t(Guests_fullNamePlaceholder), (v_2) => {
                dispatch(new Msg(60, [v_2]));
            }, form.IsSubmitting, true, (showValidation && (form.FirstName.trim() === "")) && (form.LastName.trim() === ""), vKey)), delay(() => {
                let elems_1;
                return singleton(createElement("div", createObj(ofArray([["className", "name-parsed-row"], (elems_1 = [formInput(t(Guests_firstName), form.FirstName, t(Guests_firstNamePlaceholder), (v_3) => {
                    dispatch(new Msg(62, [v_3]));
                }, form.IsSubmitting, true, showValidation && (form.FirstName.trim() === ""), vKey), createElement("button", {
                    className: "name-swap-btn",
                    title: t(Guests_swapNames),
                    children: "⇄",
                    onClick: (_arg_1) => {
                        dispatch(new Msg(61, []));
                    },
                    disabled: form.IsSubmitting,
                    type: "button",
                }), formInput(t(Guests_lastName), form.LastName, t(Guests_lastNamePlaceholder), (v_4) => {
                    dispatch(new Msg(63, [v_4]));
                }, form.IsSubmitting, true, showValidation && (form.LastName.trim() === ""), vKey)], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            })), delay(() => {
                let elems_6, elems_3, elems_2, elems_5, elems_4;
                return append(singleton(createElement("div", createObj(ofArray([["className", "form-row"], (elems_6 = [createElement("div", createObj(ofArray([["className", "form-group"], (elems_3 = [createElement("label", {
                    children: t(Guests_gender),
                }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.Gender)], ["onChange", (ev) => {
                    let matchValue_1;
                    let outArg = 0;
                    matchValue_1 = [tryParse(ev.target.value, 511, false, 32, new FSharpRef(() => outArg, (v_6) => {
                        outArg = (v_6 | 0);
                    })), outArg];
                    if (matchValue_1[0]) {
                        dispatch(new Msg(64, [matchValue_1[1]]));
                    }
                }], ["disabled", form.IsSubmitting], (elems_2 = toList(delay(() => collect((matchValue_2) => singleton(createElement("option", {
                    value: int32ToString(matchValue_2[0]),
                    children: matchValue_2[1],
                })), genderOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["className", "form-group"], (elems_5 = [createElement("label", {
                    children: t(Guests_age),
                }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.AgeCategory)], ["onChange", (ev_1) => {
                    let matchValue_3;
                    let outArg_1 = 0;
                    matchValue_3 = [tryParse(ev_1.target.value, 511, false, 32, new FSharpRef(() => outArg_1, (v_8) => {
                        outArg_1 = (v_8 | 0);
                    })), outArg_1];
                    if (matchValue_3[0]) {
                        dispatch(new Msg(65, [matchValue_3[1]]));
                    }
                }], ["disabled", form.IsSubmitting], (elems_4 = toList(delay(() => collect((matchValue_4) => singleton(createElement("option", {
                    value: int32ToString(matchValue_4[0]),
                    children: matchValue_4[1],
                })), ageCategoryOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                    let elems_8, elems_7;
                    return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_8 = [createElement("label", {
                        children: t(Guests_statusColumn),
                    }), createElement("select", createObj(ofArray([["className", "form-input"], ["value", int32ToString(form.AttendanceStatus)], ["onChange", (ev_2) => {
                        let matchValue_5;
                        let outArg_2 = 0;
                        matchValue_5 = [tryParse(ev_2.target.value, 511, false, 32, new FSharpRef(() => outArg_2, (v_10) => {
                            outArg_2 = (v_10 | 0);
                        })), outArg_2];
                        if (matchValue_5[0]) {
                            dispatch(new Msg(66, [matchValue_5[1]]));
                        }
                    }], ["disabled", form.IsSubmitting], (elems_7 = toList(delay(() => collect((matchValue_6) => singleton(createElement("option", {
                        value: int32ToString(matchValue_6[0]),
                        children: matchValue_6[1],
                    })), attendanceStatusOptions()))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                        let elems_10, elems_9;
                        return append(singleton(createElement("div", createObj(ofArray([["className", "form-row"], (elems_10 = [formInput(t(Guests_title), form.Title, t(Guests_titlePlaceholder), (v_11) => {
                            dispatch(new Msg(67, [v_11]));
                        }, form.IsSubmitting, false, false, 0), createElement("div", createObj(ofArray([["className", "form-group"], (elems_9 = [createElement("label", {
                            children: t(Guests_rank),
                        }), createElement("input", {
                            className: "form-input",
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                            placeholder: t(Guests_rankPlaceholder),
                            defaultValue: form.Rank,
                            onChange: (ev_3) => {
                                dispatch(new Msg(68, [ev_3.target.value]));
                            },
                            disabled: form.IsSubmitting,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => {
                            let elems_11;
                            return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_11 = [createElement("label", {
                                children: t(Guests_dietaryTags),
                            }), createElement(View, {
                                tags: form.DietaryTags,
                                allTags: map(DietaryOptionModule_toCode, DietaryOptionModule_allOptions),
                                disabled: form.IsSubmitting,
                                onChange: (v_13) => {
                                    dispatch(new Msg(70, [v_13]));
                                },
                                placeholderText: t(Guests_dietaryTagsHint),
                            })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => append(singleton(formTextarea(t(Guests_dietaryOther), form.DietaryNotes, 2, (v_14) => {
                                dispatch(new Msg(69, [v_14]));
                            }, form.IsSubmitting, false, false, 0)), delay(() => {
                                let elems_13, elems_12;
                                return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_13 = [createElement("label", createObj(ofArray([["className", "checkbox-label"], (elems_12 = [createElement("input", {
                                    type: "checkbox",
                                    checked: form.Wheelchair,
                                    onChange: (ev_4) => {
                                        dispatch(new Msg(71, [ev_4.target.checked]));
                                    },
                                    disabled: form.IsSubmitting,
                                }), createElement("span", {
                                    children: t(Guests_wheelchair),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))), delay(() => {
                                    let elems_14;
                                    return append(singleton(createElement("div", createObj(ofArray([["className", "form-group"], (elems_14 = [createElement("label", {
                                        children: t(Guests_tags),
                                    }), createElement(View, {
                                        tags: form.Tags,
                                        allTags: allTags,
                                        disabled: form.IsSubmitting,
                                        onChange: (v_16) => {
                                            dispatch(new Msg(72, [v_16]));
                                        },
                                        placeholderText: t(Guests_tagsHint),
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))), delay(() => append(singleton(formTextarea(t(Guests_notes), form.Notes, 3, (v_17) => {
                                        dispatch(new Msg(73, [v_17]));
                                    }, form.IsSubmitting, false, false, 0)), delay(() => {
                                        let elems_15;
                                        return singleton(createElement("div", createObj(ofArray([["className", "flex gap-sm mt-2"], (elems_15 = toList(delay(() => append(singleton(createElement("button", {
                                            className: "btn btn-primary",
                                            children: form.IsSubmitting ? t(Guests_saving) : t(Common_save),
                                            disabled: form.IsSubmitting,
                                            onClick: (_arg_3) => {
                                                if (!form.IsSubmitting) {
                                                    if (GuestEditFormModule_isValid(form)) {
                                                        dispatch(new Msg(52, []));
                                                    }
                                                    else {
                                                        dispatch(new Msg(59, []));
                                                    }
                                                }
                                            },
                                        })), delay(() => append(singleton(createElement("button", {
                                            className: "btn btn-secondary",
                                            children: t(Common_cancel),
                                            onClick: (_arg_4) => {
                                                dispatch(new Msg(51, []));
                                            },
                                            disabled: form.IsSubmitting,
                                        })), delay(() => (isEditing ? singleton(createElement("button", {
                                            className: "btn btn-danger",
                                            children: t(Guests_deleteGuest),
                                            onClick: (_arg_5) => {
                                                const matchValue_7 = form.Id;
                                                if (matchValue_7 == null) {
                                                }
                                                else {
                                                    dispatch(new Msg(57, [matchValue_7]));
                                                }
                                            },
                                            disabled: form.IsSubmitting,
                                        })) : empty()))))))), ["children", reactApi.Children.toArray(Array.from(elems_15))])]))));
                                    }))));
                                }));
                            }))));
                        }));
                    }));
                }));
            }))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_16))])])));
}

